import $ from 'jquery';
import scrollService from '../core/ScrollService.js';
const initRedirects = () => {
    if (document.querySelector('.redirectPopin_item') && document.querySelector('.redirectPopin.not-info')) {
        let popinRedirect = document.querySelector('.redirectPopin.not-info');
        redirectElt = document.querySelector('.redirectPopin_item');
        popinRedirect.classList.add('visible');
        redirectElt.classList.add('visible');
        scrollService.stop();

        let closeElements = [
            popinRedirect.querySelector('.redirectPopin_background'),
            popinRedirect.querySelector('.redirectPopin_close'),
            redirectElt.querySelector('.redirectPopin_action')
        ];

        closeElements.forEach((elt) => {
            elt.addEventListener('click', (e) => {
                e.preventDefault();
                scrollService.start();
                popinRedirect.classList.remove('visible');
            });
        });
    }
};

export { initRedirects };
